import React from 'react';
import PropTypes from 'prop-types';
import {
    Container,
    Card,
    Image,
} from 'react-bootstrap';
import ImmoMap from '@shared/components/ImmoMap';
import HousePOI from '@shared/components/HousePOI';
import ContactDetails from "@shared/components/ContactDetails";
import {
    language,
} from '@shared/language';

const i18n = {
    de: {
        address_of_property: 'Adresse des Objektes',

        imprint_label: 'Impressum',
        imprint_link: 'https://www.grundriss-schmiede.de/impressum',

        privacy_label: 'Datenschutzerklärung',
        privacy_link: 'https://www.grundriss-schmiede.de/datenschutz',
    },
    en: {
        address_of_property: 'Address of the property',

        imprint_label: 'Imprint',
        imprint_link: 'https://www.grundriss-schmiede.de/en/imprint',

        privacy_label: 'Privacy policy',
        privacy_link: 'https://www.grundriss-schmiede.de/en/data-privacy-policy',
    },
};

const undefinedIfEmpty = (val) => val && String(val).length ? String(val) : undefined;

export default class InfoTab extends React.Component {
    static propTypes = {
        tour: PropTypes.any,
        visitCardClass: PropTypes.string,
    }

    render() {
        const {
            tour,
            visitCardClass,
        } = this.props;
        const contactWeb = undefinedIfEmpty(tour.get('contactWeb'));
        const objectStreet = undefinedIfEmpty(tour.get('street'));
        const objectZip = undefinedIfEmpty(tour.get('zip'));
        const objectCity = undefinedIfEmpty(tour.get('city'));
        const latitude = undefinedIfEmpty(tour.get('latitude'));
        const longitude = undefinedIfEmpty(tour.get('longitude'));
        const position = (latitude !== undefined && longitude !== undefined) ? [latitude, longitude] : undefined;
        const showAddress = undefinedIfEmpty(tour.get('showAddress'));
        const showMap = undefinedIfEmpty(tour.get('showMap')) && position !== undefined;
        const logo = tour && tour.get('showLogo') && tour.get('logo') ? tour.get('logo') : false;

        return (
            <Container
                fluid
                className="h-100"
            >
                <ContactDetails
                    className={`mt-4 ${visitCardClass} contact-card`}
                    contact={tour.get('contact')}
                />
                <Card className="mt-2 h-50" style={{border: 0}}>
                    <div className="d-flex flex-fill">
                        {showMap ? (
                            <ImmoMap
                                width={'100%'}
                                height={'100%'}
                                center={position}
                            >
                                <HousePOI
                                    name={tour.get('name')}
                                    url={contactWeb}
                                    position={position}
                                    street={showAddress && objectStreet ? objectStreet : ''}
                                    zip={showAddress && objectZip ? objectZip : ''}
                                    city={showAddress && objectCity ? objectCity : ''}
                                    showMapLink={false}
                                    draggable={false}
                                />
                            </ImmoMap>
                        ) : (
                                logo && <Image
                                    src={logo}
                                    fluid
                                    className="d-inline-block mx-auto mt-4"
                                    />
                        )
                    }
                    </div>
                    {showAddress &&
                        <Card.Body style={{flex: 'unset'}}>
                            <p className="text-center w-100">
                                <small>
                                    <b>{i18n[language].address_of_property}</b>
                                    <br/>
                                    {objectStreet + ', ' + objectZip + ' ' + objectCity}
                                </small>
                            </p>
                        </Card.Body>
                    }
                </Card>
                <div className="text-center" style={{position: 'absolute', bottom: 0, left: 0, right: 0}}>
                    Powered by Grundriss Schmiede
                    <br />
                    <a className="" href={i18n[language].imprint_link} target="_blank" rel="noreferrer">{i18n[language].imprint_label}</a> | <a href={i18n[language].privacy_link} target="_blank" rel="noreferrer">{i18n[language].privacy_label}</a>
                </div>
            </Container>
        );
    }
}
